import { Group, Box, spacing } from '@landr/maestro';
import styled from 'styled-components';

export const FiltersContainer = styled(Box)`
    column-count: 6;
    column-gap: ${spacing('xxl')};

    ${({ theme }) => theme.breakpoint('lg')`
        column-count: 5;
    `}

    ${({ theme }) => theme.breakpoint('ml')`
        column-count: 4;
    `}

    ${({ theme }) => theme.breakpoint('md')`
        column-count: 3;
    `}

    ${({ theme }) => theme.breakpoint('ms')`
        column-count: 2;
    `}

    ${({ theme }) => theme.breakpoint('sm')`
        column-count: 1;
    `}
`;
export const FilterGroup = styled(Group)`
    gutter: ${spacing('xxs')};
    column-break-inside: avoid;
    margin-bottom: ${spacing('xxl')};
    overflow-wrap: break-word;
`;
